import React, { Fragment, useState, useEffect } from "react";
import { Grid, Typography } from "@mui/material";
import Project from "../../api/project";
import Header2 from "../../components/Header2/Header2";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import SEO from "../../components/SEO";
import TaskOrbitBanner from "../../images/TaskOrbitBanner.png";
import { LayoutDashboard, CalendarClock, Activity, Bug, PlugZap, Workflow, Columns } from "lucide-react";

const TaskOrbit = (props) => {
  const [activeFilter, setActiveFilter] = useState("all");

  const [visible, setVisible] = useState(false);
  const [activeDemo, setActiveDemo] = useState(0);

  useEffect(() => {
    setVisible(true);
    const interval = setInterval(() => {
      setActiveDemo((prev) => (prev + 1) % 5);
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  const filteredProjects =
    activeFilter === "all"
      ? Project.slice(9, 18)
      : Project.slice(9, 18).filter(
          (project) => project.category === activeFilter
        );

        const features = [
    {
      emoji: <LayoutDashboard />,
      title: 'Agile Boards',
      description: 'Visualize and manage tasks with customizable Kanban and Scrum boards.',
      color: 'indigo'
    },
    {
      emoji: <CalendarClock />,
      title: 'Smart Scrum Scheduler',
      description: 'Plan and run standups, sprint plannings, and retrospectives easily.',
      color: 'purple'
    },
    {
      emoji: <Activity />,
      title: 'Real-Time Insights',
      description: 'Track team progress, bottlenecks, and delivery timelines in real-time.',
      color: 'cyan'
    },
    {
      emoji: <Bug />,
      title: 'Issue Tracking',
      description: 'Capture, prioritize, and resolve bugs without losing momentum.',
      color: 'amber'
    },
    {
      emoji: <PlugZap />,
      title: 'Seamless Integrations',
      description: 'Connect with tools like GitHub, Jira, Slack, and more.',
      color: 'emerald'
    },
    {
      emoji: <Workflow />,
      title: 'SDLC-Focused Workflow',
      description: 'Built specifically for software development life cycles.',
      color: 'red'
    }
  ];


  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const gridStyle = {
    display: "grid",
    gridTemplateColumns: isMobile ? "repeat(1, 1fr)" : "repeat(3, 1fr)",
    gap: "16px",
    marginBottom: "32px",
  };

  return (
    <Fragment>
      <SEO
        title="Meet Task Orbit"
        description="Texora AI streamlines the hiring process with smart resume extraction, AI-powered matching, and effortless interview scheduling — making recruitment faster and smarter."
        url="https://www.ufsnetworks.com/taskorbit"
        image="https://texora.s3.ap-south-1.amazonaws.com/ufs_logo.jpg"
        canonicalUrl="https://www.ufsnetworks.com/taskorbit"
      />
      <Header2 />
      <main>
        <PageTitle
           pageTitle={"A smarter way to manage projects, teams, and tasks"}
          // pagesub={"Meet Task Orbit"}
          // pageTop={""}
        />
        <section style={{display:"grid", gridTemplateColumns:""} }>
          <Grid container spacing={2} px={4} style={{display:"flex", padding:"24px"}}>
            
            <Grid item sm={6} p={4}>
                <h3 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-800 mb-2 leading-tight">
                   Meet Task Orbit
                </h3>
                <Typography  my={1}>A comprehensive solution to streamline project teams, scrum meetings, tasks, and issues during the SDLC with real-time insights and advanced tracking — ensuring efficiency and faster delivery.</Typography>
              <h5 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-800 mb-8 leading-tight" style={{marginTop:"32px"}}>
                Managing agile teams shouldn't feel like chaos.
              </h5>
              <p className="text-xl text-gray-600 max-w-5xl mx-auto leading-relaxed">
                In today's fast-paced development cycles, staying on top of tasks, meetings, issues, and deadlines can feel overwhelming. Task Orbit brings order to the chaos with an intuitive platform that supports your entire SDLC — from backlog grooming to sprint reviews — with real-time visibility and seamless collaboration.
              </p>
              <p className="text-3xl sm:text-4xl font-bold text-gray-800 mb-4">
                Everything your team needs, in one orbit.
              </p>

              <a href="https://taskorbit-client.vercel.app/" style={{Border:"solid 1px #000", background:"blue", color:"#fff", fontSize:"16px", borderRadius:"32px", lineHeight:"normal", padding:"12px 32px"}}>View Demo</a>
            </Grid>
            <Grid item sm={6} style={{display:"flex", justifyContent:"center"}}>
             <img src={TaskOrbitBanner} alt="Texora AI" style={{height:"500px"}} />
            </Grid>
          </Grid>
        </section>
        <section className="container">
          
          {/* Content Section */}
          <div className="max-w-7xl text-start py-16 sm:py-24">
            

            {/* Key Features Section */}
            <div className="text-start mt-6" style={{paddingTop:"32px"}}>
              
              <h2 className="text-lg text-gray-600" style={{fontSize:"24px"}}>Key Features</h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" style={gridStyle}>
              {features.map((feature, index) => (
                <div
                  key={index}
                  className={`bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:border-indigo-300 transform hover:-translate-y-3 transition-all duration-500 cursor-pointer group ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}` }
                  style={{ transitionDelay: `${index * 150}ms`, padding:"16px" }}
                >
                  <h5 className="text-xl font-semibold text-gray-800 mb-3">
                   <span className="text-4xl mr-4" style={{border:"solid 1px #333", background:"#333", color:"#fff", padding:"6px", marginRight:"6px"}}>{feature.emoji}</span> {feature.title}
                  </h5>
                  <p className="text-gray-600 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default TaskOrbit;
